import { List, Skeleton, Text } from '@dixa/lib-shared-habla';
import { memo } from 'react';

import styles from './conversationMetadata.module.scss';
import {
  ConversationMetadataFields,
  getConversationMetadataFields,
} from './utils/conversationMetadata.utils';

type ConversationMetadataProps =
  | ({ isLoading?: false } & ConversationMetadataFields)
  | ({ isLoading: true } & Partial<ConversationMetadataFields>);

export const ConversationMetadata = memo(function ConversationMetadata(
  props: ConversationMetadataProps,
): JSX.Element {
  if (props.isLoading) {
    return (
      <List>
        {Array.from({ length: 6 }, (_, index) => (
          <List.Item
            key={index}
            className={styles.item}
            withHoverEffect={false}
            contentLeft={
              <div className={styles.itemKey}>
                <Skeleton height="14px" width="80px" />
              </div>
            }
            contentRight={
              <div className={styles.itemValue}>
                <Skeleton height="14px" width="160px" />
              </div>
            }
          />
        ))}
      </List>
    );
  }

  return (
    <List>
      {getConversationMetadataFields(props).map(({ key, value }) => (
        <List.Item
          key={key}
          className={styles.item}
          withHoverEffect={false}
          contentLeft={
            <Text.Paragraph className={styles.itemKey}>{key}</Text.Paragraph>
          }
          contentRight={
            <Text.Paragraph className={styles.itemValue}>
              {value}
            </Text.Paragraph>
          }
        />
      ))}
    </List>
  );
});
